import React, { useState } from "react";
import "../assets/css/Login.css";
import { FaEnvelope, FaLock } from "react-icons/fa";
import LoginPc from "../assets/images/computer.png";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import CircularProgress from "@mui/material/CircularProgress";
import { useTranslation } from "react-i18next";

const loginSchema = yup.object().shape({
  Username: yup.string().required("User Name Is Required"),
  Password: yup.string().required("Password Is Required"),
  Role: yup.string().required("Role is required"),
});

const Login = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(loginSchema),
  });

  const onSubmit = async (data) => {
    setLoading(true);
    setErrorMessage("");

    const roleID = data.Role === "admin" ? 6 : 7;

    try {
      const res = await axios.post(
        "https://anydev.com-eg.net/api/Users/V1/Login",
        {
          userName: data.Username,
          password: data.Password,
          roleID,
        },
        {
          headers: { CompanyID: "212606" },
        }
      );

      // جسم الاستجابة
      const payload = res?.data ?? {};

      // محاولات مرنة لاستخراج التوكن ولو كان اسمه مختلف/داخل كائن
      const token =
        payload.accessToken ??
        payload.token ??
        payload?.data?.accessToken ??
        payload?.data?.token;

      const isActive = payload.isActive ?? payload?.data?.isActive ?? true; // اعتبره true لو الـ API مش بيرجّعه

      if (!token) {
        setErrorMessage("لم يتم استلام رمز الدخول (token) من السيرفر.");
        return;
      }

      if (!isActive) {
        setErrorMessage("الحساب غير مُفعّل.");
        return;
      }

      // خزّن كل الداتا اللي رجعت + الدور المستنتج
      const userDataToSave = { ...payload, roleID };
      localStorage.setItem("userData", JSON.stringify(userDataToSave));

      // بعد ما تخزّن، انتقل
      navigate("/home-page", { replace: true });
    } catch (error) {
      if (error.response?.status === 401) {
        localStorage.removeItem("userData");
        setErrorMessage("بيانات الدخول غير صحيحة.");
        navigate("/");
      } else {
        setErrorMessage("حدث خطأ أثناء محاولة تسجيل الدخول.");
      }
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container">
      {loading ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
            width: "100%",
            position: "fixed",
            top: 0,
            left: 0,
            backgroundColor: "rgba(255, 255, 255, 0.8)",
            zIndex: 1000,
          }}
        >
          <CircularProgress size={80} />
        </div>
      ) : (
        <div className="login-container">
          <div className="login-card">
            <div className="login-image">
              <img src={LoginPc} alt="Login Illustration" />
            </div>
            <div className="login-form">
              <h2>{t("login")}</h2>
              <form onSubmit={handleSubmit(onSubmit)}>
                <div className="input-group">
                  <FaEnvelope className="input-icon" />
                  <input
                    type="text"
                    placeholder={t("username")}
                    {...register("Username")}
                  />
                  {errors.Username && (
                    <p className="error-message">{errors.Username.message}</p>
                  )}
                </div>
                <div className="input-group">
                  <FaLock className="input-icon" />
                  <input
                    type="password"
                    placeholder={t("password")}
                    {...register("Password")}
                  />
                  {errors.Password && (
                    <p className="error-message">{errors.Password.message}</p>
                  )}
                </div>

                <div className="input-group">
                  <select className="input" {...register("Role")}>
                    <option value="">{t("selectRole") || "Select Role"}</option>
                    <option value="admin">{t("admin") || "Admin"}</option>
                    <option value="user">{t("user") || "User"}</option>
                  </select>
                  {errors.Role && (
                    <p className="error-message">{errors.Role.message}</p>
                  )}
                </div>
                {errorMessage && (
                  <div className="error-message">{errorMessage}</div>
                )}
                <div className="input-group">
                  <button
                    type="submit"
                    className="login-button"
                    disabled={loading}
                  >
                    {t("login")}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Login;
